"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SupplierAgreementTransferValidationDTO_1 = require("./SupplierAgreementTransferValidationDTO");

var WindowItemTransferValidationDTO_1 = require("./WindowItemTransferValidationDTO");
/**
 * @author Tomáš Leity
 * @author PKr
 */


var WindowCopyResultDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowCopyResultDTO, _DomainObject_1$Domai);

  /**
   * @param id internal entity id which is needed for repository
   * @param monitorId id of progress monitor which is
   * @param sourceWindowId - copied window id
   * @param targetWindowId - new window id of copied window
   * @param sessionId - assigned sessionId for new window
   * @param windowItemValidation
   * @param supplierAgreementValidation
   */
  function WindowCopyResultDTO(id, monitorId, sourceWindowId, targetWindowId, sessionId, windowItemValidation, supplierAgreementValidation) {
    var _this;

    _classCallCheck(this, WindowCopyResultDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowCopyResultDTO).call(this));
    _this.id = id;
    _this.monitorId = monitorId;
    _this.sourceWindowId = sourceWindowId;
    _this.targetWindowId = targetWindowId;
    _this.sessionId = sessionId;
    _this.windowItemValidation = windowItemValidation;
    _this.supplierAgreementValidation = supplierAgreementValidation;
    return _this;
  }
  /**
   *  Returns true when {@link WindowMoveResultDTO.windowItemValidation} or {@link WindowMoveResultDTO.supplierAgreementValidation}
   *  contains validation violation
   */


  _createClass(WindowCopyResultDTO, [{
    key: "wasTransferInvalid",
    value: function wasTransferInvalid() {
      var wasInvalid = false;

      if (this.windowItemValidation.size > 0 && this.windowItemValidation.some(function (v) {
        return v.flags.size() > 0;
      })) {
        wasInvalid = true;
      }

      if (this.supplierAgreementValidation.size > 0 && this.supplierAgreementValidation.some(function (v) {
        return v.flags.size() > 0;
      })) {
        wasInvalid = true;
      }

      return wasInvalid;
    }
  }]);

  return WindowCopyResultDTO;
}(DomainObject_1.DomainObject);

exports.WindowCopyResultDTO = WindowCopyResultDTO;

WindowCopyResultDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowCopyResultDTO.name);
  return {
    id: builder.str('id'),
    monitorId: builder.str('monitorId'),
    sourceWindowId: builder.str('sourceWindowId'),
    targetWindowId: builder.str('targetWindowId'),
    sessionId: builder.str('sessionId'),
    windowItemValidation: builder.listOf(builder.obj('windowItemValidation', WindowItemTransferValidationDTO_1.WindowItemTransferValidationDTO.schema, function (mat) {
      return new WindowItemTransferValidationDTO_1.WindowItemTransferValidationDTO(mat.windowItemId, mat.productId, mat.flags);
    })),
    supplierAgreementValidation: builder.listOf(builder.obj('supplierAgreementValidation', SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO.schema, function (mat) {
      return new SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO(mat.supplierAgreementId, mat.windowItemId, mat.supplierId, mat.flags);
    }))
  };
}();